import React, { CSSProperties } from "react"
import { graphql, Link } from "gatsby"
import MainPage from "./MainPage"
import { useSiteContext } from "../components/common/SiteContext"
import { DividedBlade, EDividedBladeDirection } from "@organic-return/foundation-react/src/components/Blades/DividedBlade"
import { Search } from "@organic-return/foundation-react/src/components/Search/Search"
import { ContactCard, EContactCardLayout } from "@organic-return/foundation-react/src/components/Contact/ContactCard"
import { ContactForm } from "@organic-return/foundation-react/src/components/Forms/ContactForm"
import { BackgroundImage } from "@organic-return/foundation-react/src/components/Media/BackgroundImage"

export const query = graphql`
  query($nodeID: String!) {
    drupalBuilders(id: { eq: $nodeID }) {
        builderDescription
        builderLogo {
          url          
          height
          width
        }
        builderName
        agentRepresentingBuilder       
        agent {
            fullName
            phone
            phoneMobile
            phoneOffice
            workTitle
            photos {
              url
            }
            path
        }
        sEOTitle
        sEODescription 
    }
  }
`

const BuilderPage = ({data, location }: any) => {
    const siteContext = useSiteContext()
    const builder = data.drupalBuilders

    const linkf = (props: any) => {
        return (
            <Link
                to={props.href}
                className={`hide-disabled text-inherit ${props.className}`}
                key={props.key}
                title={props.title}
            >
                {props.children}
            </Link>
        )
    }

    let bgImageClasses = "relative flex flex-row flex-wrap items-end justify-center w-full mt-2"
    let bgImageStyle: CSSProperties = {
        height: 300,
        backgroundPosition: "center",
        backgroundSize: "contain",
        backgroundRepeat: "no-repeat"
    }

    const sizesAndAspect = [
        {
            media: "min-width:1px",
            width: 420,
        },
        {
            media: "min-width:420px",
            width: 640,
        },
        {
            media: "min-width:640px",
            width: 768,
        },
        {
            media: "min-width:768px",
            width: 1024,
        },
        {
            media: "min-width:1024px",
            width: 1280,
        },
        {
            media: "min-width:1280px",
            width: 1440,
        },
        {
            media: "min-width:1440px",
            width: 1536,
        },
    ]

    var pageTitle = builder.sEOTitle;
    var pageDescripton = data.drupalBuilders.sEODescription;
    //var pageKeywords = data.drupalBuilders.seo?.metaKeywords;
    var pageKeywords = "";

    return (
        <MainPage
            headerProps={{ gradient: true, ...siteContext.headerProps }}
            seoProps={{ title: pageTitle, description: pageDescripton, keywords: pageKeywords, location: location }}
            className="builder-page"
        >
            <>
                <BackgroundImage
                    src={builder.builderLogo?.url}
                    className={`heading-module ${bgImageClasses}`}
                    style={bgImageStyle}
                    sizesAndAspect={sizesAndAspect}
                    children={null}
                >
                </BackgroundImage>
                <DividedBlade
                    className="max-w-4xl mx-auto"
                    direction={EDividedBladeDirection.column}
                    firstSection={{
                        header: builder.builderName,
                        titleHeadingLevel: "h1",
                    }}
                    secondSection={{
                        text: builder.builderDescription
                    }}
                />
                {builder.agent && builder.agent.length > 0 && (
                    <>
                        <h1 className="inverted">Featured Agents</h1>
                        <Search
                            index={builder.agent}
                            pageSize={0}
                            showCount={false}
                            className="featured-agents-search inverted flex flex-col items-center"
                            resultsClassName="max-w-screen-2xl mx-auto"
                            headerClassName="hidden"
                            filterClassName="hidden"
                            renderItem={(item, index) => {
                                return (
                                    <ContactCard
                                        contact={item}
                                        layout={EContactCardLayout.horizontal}
                                        maxWidthImage={200}
                                        className="w-full sm:w-1/2 xl:w-1/3 p-4"
                                        showVCard={false}
                                        key={index}
                                        linkFunc={linkf}
                                        {...siteContext.globalPeopleSearchCardProps}
                                    />
                                )
                            }}
                            preRenderItem={(item, index) => {
                                return (
                                    <a key={index} href={item.path}></a>
                                )
                            }}
                        />
                    </>
                )}
                <ContactForm {...siteContext.globalContactFormProps} />
            </>
        </MainPage>
    )
}

export default BuilderPage